import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {TestFilters} from '../../../../data/models/filters/test-filters';

@Component({
  selector: 'app-test-filters',
  templateUrl: './test-filters.component.html',
  styleUrls: ['./test-filters.component.css']
})
export class TestFiltersComponent implements OnInit, OnChanges {

  @Input() filters: TestFilters = {};

  @Output() apply = new EventEmitter<TestFilters>();

  public form!: FormGroup;

  constructor(
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      search: [''],
      type: [null],
      isActivated: [null],
    });
  }

  ngOnInit(): void {
    this.form.controls.search.setValue(this.filters.search);
    this.form.controls.type.setValue(this.filters.type);
    this.form.controls.isActivated.setValue(this.filters.isActivated);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filters = changes.filters.currentValue;
    this.form.controls.search.setValue(filters.search);
    this.form.controls.type.setValue(filters.type);
    this.form.controls.isActivated.setValue(filters.isActivated);
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    const search = this.form.controls.search.value || null;
    const type = this.form.controls.type.value;
    const isActivated = this.form.controls.isActivated.value;
    this.apply.emit({search, type, isActivated});
  }

  onClear(event: MouseEvent): void {
    event.preventDefault();
    this.form.controls.search.setValue('');
    this.form.controls.type.setValue(null);
    this.form.controls.isActivated.setValue(null);
    this.apply.emit({});
  }

}
